import script from "./viewNotice.vue?vue&type=script&setup=true&lang=js"
export * from "./viewNotice.vue?vue&type=script&setup=true&lang=js"

import "./viewNotice.vue?vue&type=style&index=0&id=3f8474d8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f8474d8"]])

export default __exports__